import React from "react";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { motion } from "framer-motion";
import { Squiggle } from "./Scribbles";
import { PROFILE } from "../data/content";
import { downloadResume } from "../lib/downloadResume";

export const ResumeButton = ({ testId = "download-resume", variant = "dark" }) => {
  const handleClick = async () => {
    if (!PROFILE.resumeUrl) {
      toast("Resume not ready yet!", {
        description: "Arya is putting the finishing touches on it. Check back soon.",
      });
      return;
    }
    toast("Downloading resume", { description: PROFILE.resumeFilename });
    await downloadResume();
  };

  const base =
    "group relative inline-flex items-center gap-3 px-8 py-4 border-2 border-ink uppercase tracking-widest text-sm transition-colors duration-300";
  const styles =
    variant === "dark"
      ? "bg-ink text-sand hover:bg-terracotta hover:border-terracotta"
      : "bg-transparent text-ink hover:bg-ink hover:text-sand";

  return (
    <motion.button
      onClick={handleClick}
      className={`${base} ${styles}`}
      data-testid={testId}
      whileTap={{ scale: 0.97 }}
    >
      <Download size={18} />
      Download Resume
      <Squiggle
        width={80}
        className="absolute -bottom-4 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
      />
    </motion.button>
  );
};
